import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import MissionStatementPage from './pages/MissionStatementPage';
import PrincipalsMessagePage from './pages/PrincipalsMessagePage';
import CellPhonePolicyPage from './pages/CellPhonePolicyPage';
import UniformPolicyPage from './pages/UniformPolicyPage';
import StaffDirectoryPage from './pages/StaffDirectoryPage';
import MentalHealthResourcesPage from './pages/MentalHealthResourcesPage';
import LearningResourcesPage from './pages/LearningResourcesPage';
import ContactPage from './pages/ContactPage';
import CalendarPage from './pages/CalendarPage';
import ComingSoonPage from './pages/ComingSoonPage';
import GalleryPage from './pages/GalleryPage';
import DualLanguageProgramPage from './pages/DualLanguageProgramPage';
import ParentPortalPage from './pages/ParentPortalPage';
import HandbookPage from './pages/HandbookPage';
import MonthlyUpdatesPage from './pages/MonthlyUpdatesPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/mission-statement" element={<MissionStatementPage />} />
        <Route path="/principals-message" element={<PrincipalsMessagePage />} />
        <Route path="/cell-phone-policy" element={<CellPhonePolicyPage />} />
        <Route path="/uniform-policy" element={<UniformPolicyPage />} />
        <Route path="/staff-directory" element={<StaffDirectoryPage />} />
        <Route path="/mental-health-resources" element={<MentalHealthResourcesPage />} />
        <Route path="/learning-resources" element={<LearningResourcesPage />} />
        <Route path="/dual-language-program" element={<DualLanguageProgramPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/calendars" element={<CalendarPage />} />
        <Route path="/handbook" element={<HandbookPage />} />

        {/* Coming Soon Pages */}
        <Route path="/about" element={<ComingSoonPage />} />
        <Route path="/administrative-team" element={<ComingSoonPage />} />
        <Route path="/policies-procedures" element={<ComingSoonPage />} />
        <Route path="/students" element={<ComingSoonPage />} />
        <Route path="/parents" element={<ComingSoonPage />} />
        <Route path="/parent-portal" element={<ParentPortalPage />} />
        <Route path="/academics" element={<ComingSoonPage />} />
        <Route path="/classes" element={<ComingSoonPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/news" element={<ComingSoonPage />} />
        <Route path="/news/monthly-updates" element={<MonthlyUpdatesPage />} />
        <Route path="/news/:slug" element={<ComingSoonPage />} />
        <Route path="/privacy" element={<ComingSoonPage />} />
        <Route path="/accessibility" element={<ComingSoonPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
